var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.8 189.7",
    style: {
      enableBackground: "new 0 0 132.8 189.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#A994FF;}\n\t.st2{fill:#1592C8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_23_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_22_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_21_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_20_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_19_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.9,154.5C32.9,154.5,32.9,154.5,32.9,154.5C32.9,154.5,32.9,154.5,32.9,154.5 C32.9,154.5,32.9,154.5,32.9,154.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_18_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_17_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_16_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_15_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.2,0C85.2,0,85.2,0,85.2,0L85.2,0C85.2,0,85.2,0,85.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,189.2c-1.9-3.1-4.6-8.5-6.9-12.9c-7-15.4-12.7-33.5-12.3-51c0,0,0,0,0,0c0-1.9,0.1-3.7,0.1-5.6 c0.1-3.2,0.2-6.4,0.2-9.6c0.1-3.2,0.2-6.4,0.2-9.6c0.1-3.1,0.1-6.3,0.2-9.4C0.9,87.9,1,84.8,1,81.6c0.1-3.1,0.1-6.1,0.2-9.2 c0.1-2.4,0.1-4.8,0.2-7.2c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.2,0-0.4,0.2-0.6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.3,0,0.5,0 c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.3,0.6,0.6,1,0.9c0.6,0.5,1.2,1.1,1.8,1.6c4.8,4.4,9.6,8.7,14.4,13.1 c0.7,0.6,1.3,1.2,2,1.8c22-13,52.3-2.5,74.6,12.4c4.9,3.2,9.3,6.7,13.3,10.1c8.3,7,15.9,14.9,22.6,23.4c0.2,0.2,0.1,0.6-0.1,0.8 c-0.3,0.2-0.6,0.1-0.8-0.2c-9.2-11.5-19.8-21.8-31.8-30.5c-1.1-0.8-2.1-1.5-3.2-2.2C81,84.9,62.6,76.6,43.4,77.1 c-0.8,0-1.5,0.1-2.3,0.2c-2.9,0.5-6.2,1.5-7.7,4.4c-2.2,4.6,1.9,10.5,4.7,14c0.8,1,1.7,2,2.6,3c3.7,3.4,7.4,6.7,11.1,10.1 c5.3,4.9,10.7,9.7,16,14.6c5.4,4.9,10.8,9.8,16.1,14.7c4.2,3.8,8.4,7.7,12.7,11.5c1.1,1,2.2,2,3.3,3c5.4,4.9,10.7,9.8,16.1,14.6 c5.1,4.6,10.2,9.3,15.3,13.9c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.2,0.3,0.6,0.1,0.8c0,0,0,0,0,0c-0.2,0.2-0.6,0.2-0.8,0 c-4.8-4.3-9.5-8.7-14.3-13c-5.4-4.9-10.7-9.8-16.1-14.6c-1.3-1.2-2.6-2.4-3.9-3.6c-4-3.7-8.1-7.3-12.1-11 c-5.3-4.9-10.7-9.7-16-14.6c-5.3-4.8-10.7-9.7-16-14.5c-3.2-2.9-6.4-5.8-9.6-8.7c-0.9-0.7-1.8-1.5-2.7-2.2c-5.1-3.8-11-7-17.5-7.2 c-9.2-0.3-15.4,5.7-18.7,13.8c-0.1,0.2-0.2,0.5-0.3,0.7c-1.1,3.5-1.8,7.1-2.2,10.9c0,0,0,0,0,0c0,0.1,0,0.2,0,0.2 c0,0.1,0,0.2,0,0.4c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0.1c0,0,0,0,0,0c-0.3,3-0.4,6.1-0.3,9.2c0.6,21.4,8.3,42,18.9,60.3 c0.3,0.5,0.2,0.8,0,0.9C19.8,189.8,19.5,189.7,19.2,189.2z M20.3,82.9c-0.3-0.3-0.7-0.7-1-1c-2-1.9-4.7-3.8-7.6-3.8 c-0.6,0-1.2,0.1-1.8,0.3c-5.4,1.8-6.7,11.2-7.1,16.2c-0.1,1.4-0.2,2.9-0.2,4.3c0,0.8,0,1.6,0,2.4c0,0.8-0.1,1.6-0.1,2.4 c-0.1,1.9-0.2,3.9-0.3,5.8C3.6,104,5.8,98.8,9,93.9C12.3,89.3,16.1,85.6,20.3,82.9z"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_14_"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_13_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Vektorebene_12_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.d1be67031536282ad76205c6c0f9d832.svg";
export { ForwardRef as ReactComponent };